export default __webpack_public_path__ + "static/media/diagram.07bb3812.png";